// Stub utility functions for BIM project (copied buyer components reference these)

export const setDeadlineDays = (date: string) => {
  const now = new Date();
  const deadline = new Date(date);
  const diff = deadline.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const findUpper = (str: string) => {
  if (!str) return "";
  const words = str.split(" ");
  return words.map((w) => w.charAt(0).toUpperCase()).join("");
};

export const setDateForPicker = (date: string) => {
  if (!date) return new Date();
  return new Date(date);
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED",
    minimumFractionDigits: 2,
  }).format(amount);
};

export const exportToXLSX = (data: any[], fileName: string) => {
  console.log("Export to XLSX:", fileName, data.length, "rows");
};
